import { Effect } from 'effect';

import { createCustomer } from '../../../request/backendApi/customer/createCustomer';
import { RuntimeClientAtom } from '../../../runtime/RuntimeClient';
import type { CustomerRegisterPayload } from '@vs-shop/schemas/customer';

export const registerCustomerAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (data: CustomerRegisterPayload) {
    return yield* createCustomer(data);
  })
);
